import { http } from '../utils/http/index'

export interface ApiResponse<T = any> {
  errcode: number
  errmsg: string
  data: T
}

export class CommonApi {
  // 上传图片
  async uploadImage(url: string, options?: {}) {
    return http.uploadFile(url, 'image', options)
  }

  // 上传视频
  async uploadVideo(url: string, options?: {}) {
    return http.uploadFile(url, 'video', options)
  }

  // 用户登录
  async login(params: any) {
    return http.post('/auth/login', params)
  }

  async logout() {
    return Promise.resolve()
  }

  // 检查微信token
  async checkToken(params: any) {
    return http.post('/wechat-applet/check-token', params)
  }

  // 获取用户信息
  async getSelfInfo(params: any) {
    return http.get('/auth/getSelfInfo', params)
  }

  // 更新用户信息
  async updateSelfInfo(params: any) {
    return http.post('/auth/updateSelfInfo', params)
  }

  // 意见反馈提交
  async feedbackAdd(params: any) {
    return http.post('/auth/putFeedback', params)
  }
  // 意见反馈列表
  async feedbackList(params: any) {
    return http.get('/complaint/opinionList', params)
  }
  // 意见详情
  async feedbackDetail(params: any) {
    return http.get('/complaint/opinionDetail', params)
  }

  // 获取服务分类列表
  async getServiceCategory(params: any) {
    return http.get('/category/getList', params)
  }

  // 获取服务分类列表根据版本号
  async getServiceCategoryByVersion(params: any) {
    return http.get('/category/getByVersion', params)
  }

  // 获取园区首页快捷服务分类列表
  async getHomeServiceCategory(params: any) {
    return http.get('/category/getParkList', params)
  }

  // 金刚区-列表新接口
  async getCategoryQuickList(params: any) {
    return http.get('/category/getCategoryQuickList', params)
  }

  // 获取省级列表
  async getRegion(params: any) {
    return http.get('/region/index', params)
  }
  // 获取下级列表
  async getRegionChildren(params: any) {
    return http.get('/region/getChildren', params)
  }
  // 获取名称
  async getRegionName(params: any) {
    return http.get('/region/getName', params)
  }

  // 获取系统配置
  async getConfig(params: any) {
    return http.get('/site/getConfig', params)
  }

  // 获取省市区总列表
  async getRegionTotalList(params: any) {
    return http.get('/region/totalList', params)
  }
  // 字典
  async dictValue(params: any) {
    return http.get('/user/user/dictValue', params)
  }
}
